var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLongformH3 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 17,
  height: 12,
  viewBox: "0 0 17 12",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M.013 9.858h4.03v-.736l-1.13-.235V5.459H7.16v3.434l-1.13.235v.73h4.088v-.73l-1.136-.241V.984l1.073-.127V0H6.1v.857l1.06.12v3.466H2.914V.983L3.98.858V0H0v.857L1.085.99v7.89l-1.072.242zm11.318 1.054c0 .323.006.615.006.94 3.39.608 5.624-1.328 5.624-3.302 0-1.295-.997-2.247-2.622-2.221 1.016-.318 2.032-1.416 2.032-2.412 0-1.537-1.308-2.114-2.546-2.114-1.555 0-2.602.742-2.9 1.06l.45.698c.432-.298.984-.673 1.974-.673.622 0 1.27.343 1.257 1.25-.006 1.207-1.466 1.816-2.463 1.968v1.035l1.193-.26c1.556.101 1.822 1.022 1.822 1.815 0 1.606-1.777 2.66-3.827 2.216"
})));
export default SvgLongformH3;